import { secondsSinceTelemetryTimestamp } from './telemetry-time';

export function gpsWarning(position: { gps_valid_stamp?: unknown; stamp?: unknown }, now: Date): string {
  const seconds = secondsSinceTelemetryTimestamp(position.gps_valid_stamp ?? position.stamp, now);
  if (seconds === null) return 'GPS impreciso — horário da posição válida indisponível';
  const minutes = Math.max(0, Math.floor(seconds / 60));
  return `GPS impreciso — posição válida há ${minutes} ${minutes === 1 ? 'minuto' : 'minutos'}`;
}
